import {Injectable} from '@angular/core';
import {HttpClient, HttpEventType} from '@angular/common/http';
import {FileDto, FileUploadProgressTypes, UploadProgress} from '../models/file';
import {Observable} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import * as saveAs from 'file-saver';
import { environment } from 'src/environments';

@Injectable()
export class PublicFilesService {
  private apiEndPoint: string;
  private endpoint: string;
  constructor(private http: HttpClient,
  ) {
  this.apiEndPoint = environment.apiUrl;
  }

  postFileWithProgress(file: FileDto, endpoint?: string): Observable<UploadProgress<FileDto>> {
    if(endpoint){
      this.endpoint = endpoint;
    } 

    return this.http
      .post<FileDto>(`${this.apiEndPoint}/${this.endpoint}`, file, {reportProgress: true, observe: 'events'})
      .pipe(
        map(ev => {
          switch (ev.type) {
            case HttpEventType.UploadProgress:
              return {
                status: FileUploadProgressTypes.UPLOADING,
                progress: (ev.loaded / ev.total) * 100,
              };
            case HttpEventType.Response:
              return {
                status: FileUploadProgressTypes.FINISHED,
                progress: 100,
                data: ev.body,
              };
            case HttpEventType.DownloadProgress:
              return {
                status: FileUploadProgressTypes.PROCESSING,
                progress: 101,
              };
            default:
              return {
                status: FileUploadProgressTypes.LOADING,
              };
          }
        })
      );
  }

  downloadFileTemplate(templateId) {
    return this.http
      .get<{ data: string, mimeType: string, fileName: string }>(`${this.apiEndPoint}/FileStorage/GetFileDownloadDto/${templateId}`)
      .pipe(
        tap(data => {
          fetch(`data:${data.mimeType};base64,${data.data}`)
            .then(res => res.blob())
            .then(blob => saveAs(blob, data.fileName));
        }),
      )
  }

}
